<template>
	<IconButtonLayout class="chevron-left-button">
		<template #default="{ iconClass }">
			<FontAwesomeIcon
				:title="title"
				:class="iconClass"
				:icon="[ `fas`, `chevron-left`]"
			/>
		</template>
	</IconButtonLayout>
</template>

<script>
import IconButtonLayout from "./IconButtonLayout.vue";

export default {
	name: "ChevronLeftButton",
	components: {
		IconButtonLayout,
	},
	props: {
		title: {
			type: String,
			default: "",
		},
	},
};
</script>

<style lang="scss" scoped></style>
